<template>
  <el-row>
    <el-row class="list-dot-tit">
      <strong class="list-tit"><span>알람 이력</span></strong>
      <el-table-wrapper :column-default="columnDefault" :data="eventHists" :columns="eventHistColumns" :pagination="false" max-height="300"
        :show-custom-header="false" header-align="center" highlight-current-row>
        <template slot-scope="scope" slot="eventlevel-slot">
          <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
        </template>
        <template slot-scope="scope" slot="check-datetime-slot">
          {{ getDateToString(scope.row.checkDatetime, 'YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-wrapper>
    </el-row>
  </el-row>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';
import LogAPI from '@/api/log/integrated-log';
import { columnDefault } from '@/constants/table';
import { getIntervalDatetimeParams, getDateToString } from '@/utils/date';
import WEventlevelCell from '@/components/table/EventlevelCell';

export default {
  name: 'WDetailAlramHist',
  components: {
    WEventlevelCell,
  },
  props: {
    eventInfo: Object,
  },
  data() {
    return {
      columnDefault,
      eventHists: [],
      eventHistColumns: [
        {
          label: '이벤트 등급',
          prop: 'eventlevel',
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          searchable: true,
          searchType: 'eventlevel',
          remoteProp: 'eventlevelId',
          className: 'eventlevel',
          width: 100,
        },
        {
          label: '발생 조건',
          prop: 'eventConditionLabel',
        },
        {
          label: '발생 시각',
          prop: 'checkDatetime',
          scopedSlot: 'check-datetime-slot',
          width: 200,
        },
      ],
    };
  },
  watch: {
    eventInfo: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value) && !isNil(value.eventSeq)) {
          // 선택한 이벤트에 따라 해당 event_id, eventlevel_id로 알람 이력 조회해오는 loadData 함수 필요
          this.loadData();
        }
      },
    },
  },
  methods: {
    getDateToString,
    loadData() {
      const params = {
        eventId: this.eventInfo.eventInfo.eventId,
        checkDatetime: getIntervalDatetimeParams(this.eventInfo.checkDatetime, 'hour', 3),
        endCheckDatetime: this.eventInfo.checkDatetime,
        limit: 10,
      };
      LogAPI.getLogEventHists(params).then((response) => {
        if (response.data.success) {
          this.eventHists = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '알람', false));
        throw new Error(e);
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/Event/DetailEventHist.vue